import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { Phone, Lock } from "lucide-react";
import { useResident } from "../context/ResidentAuth";
import { errMsg } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export default function LoginPage() {
  const { resident, login } = useResident();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  if (resident) return <Navigate to="/odemeler" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(phone, password);
      nav(loc.state?.from || "/odemeler", { replace: true });
    } catch (er) {
      setErr(errMsg(er, "Giriş yapılamadı"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12 sm:py-20 grid lg:grid-cols-2 gap-10 items-center">
      <div className="hidden lg:block relative h-[520px] rounded-[2rem] overflow-hidden">
        <img src="/on_kapi_girisi.jpg" alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40" aria-hidden="true" />
        <p className="absolute bottom-8 left-8 right-8 font-display text-3xl font-bold text-white tracking-tight">Ödemeleriniz ve talepleriniz tek yerde.</p>
      </div>
      <div className="max-w-md w-full mx-auto fade-up">
        <p className="eyebrow text-[#E07A5F]">Malik & Kiracı Girişi</p>
        <h1 className="font-display text-4xl font-bold tracking-tight text-[#1B4332] mt-2">Giriş yapın</h1>
        <p className="text-slate-500 mt-3 text-sm">Sistemde kayıtlı cep telefonu numaranız ve şifrenizle giriş yapın.</p>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="resident-login-form">
          <label className="block">
            <span className="text-sm font-semibold text-slate-700">Cep telefonu</span>
            <div className="relative mt-1">
              <Phone size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input required inputMode="tel" placeholder="05XX XXX XX XX" value={phone} onChange={(e) => setPhone(e.target.value)} className="h-12 pl-11 rounded-xl bg-white" data-testid="resident-phone-input" />
            </div>
          </label>
          <label className="block">
            <span className="text-sm font-semibold text-slate-700">Şifre</span>
            <div className="relative mt-1">
              <Lock size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 pl-11 rounded-xl bg-white" data-testid="resident-password-input" />
            </div>
          </label>
          {err && <p className="text-sm text-red-600 font-medium" data-testid="resident-login-error">{err}</p>}
          <Button type="submit" disabled={busy} className="w-full h-12 rounded-full bg-[#1B4332] hover:bg-[#143326] font-bold text-base" data-testid="resident-login-submit">
            {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
          </Button>
        </form>
        <p className="text-xs text-slate-400 mt-6">Şifreniz yoksa site yönetiminden şifre belirleme bağlantısı isteyin.</p>
        <Link to="/yonetim/giris" className="inline-block mt-2 text-xs font-semibold text-slate-500 hover:text-[#1B4332]" data-testid="admin-login-link">Yönetici misiniz? Yönetim paneline giriş</Link>
      </div>
    </div>
  );
}
